import FBGrabedPostList from '@/data/fbGrabedPost/view/list.vue'

const list = {
  path: '/fb-post',
  name: 'fbpost-list',
  component: FBGrabedPostList
}

export default [list]
